module.exports = __webpack_public_path__ + "img/description.099b3481.svg";